export { default } from "./customer.api"
